import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { DASHBOARD_URL } from "../../api/AdminUrls";
import { get } from "../../services/smartApiService";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
  
);

const BarChart = () => {
    const [chartData, setChartData] = useState<any[]>([]);

  const loadTableData = () => {
    let URL = DASHBOARD_URL.GET_ALL_TRAINEE_PROJECT;
    const subscription = get(URL).subscribe((response) => {
      setChartData(response.data );
       console.log("Chart Response",response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);
  const [startYear, setStartYear] = useState(new Date().getFullYear());
  const data = {
  labels: chartData.map((item) => item?.project_name), // Extract project names
  datasets: [
    {
      label: "",
      data: chartData.map((item) => item?.totcount), // Extract total counts
      backgroundColor: ["#6511e0", "#4ca6e1", "#50be6a", "#fcb90d", "#ff8099"],
      borderColor: ["#6511e0", "#4ca6e1", "#50be6a", "#fcb90d", "#ff8099"],
      borderWidth: 1,
    },
  ],
};


const options: ChartOptions<"bar"> = {
  responsive: true,
  plugins: {
    legend: { display: false }, // Show legend
    datalabels: {
      anchor: "end", // Position label at the top
      align: "top",
      color: "black",
      font: {
        weight: "bold",
        size: 14,
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true, // Start Y-axis at 0
      suggestedMax: 10, 
       ticks: {
          callback: function (value: any) {
            // Only show labels if the value is an integer
            return Number.isInteger(value) ? value : '';
          }
        },
    },
  },
};
  const handleChangeYear = (changeNo: number) => {
    setStartYear((prevYear) => prevYear + changeNo);
  };

  const dateRange = () => (
    <div className="date-navigation flex-between">
      <span className="icon is-clickable" onClick={() => handleChangeYear(-1)}>
        <i className="fa fa-arrow-left"></i>
      </span>
      <span className="mx-2">{startYear}</span>
      <span className="icon is-clickable" onClick={() => handleChangeYear(1)}>
        <i className="fa fa-arrow-right"></i>
      </span>
    </div>
  );

  return (
    <>
      <div className="flex-between mb-1 p-1">
        <div className="is-size-6 has-text-weight-bold">
          Project Wise Loco Pilots Assessed
        </div>
      </div>

      <Bar data={data} options={options} height={400} />
    </>
  );
};

export default BarChart;
